import { useOptionMaxStockNum as useMaxStockNum } from "@/components/features/items/edit/option/_shared/ui/components/max-stock-num/hooks";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionMaxStockNum = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { maxStockNum } = viewModel;

	return useMaxStockNum({ maxStockNum, onSetViewModel });
};
